export default __webpack_public_path__ + "static/media/ar.ac7e991e.png";